export default {
    setDirectoryFilter: (eventId, directoryId, filter) => {
        return {
            type: 'SET_DIRECTORY_FILTER',
            eventId,
            directoryId,
            filter,
        };
    },
    resetDirectoryFilter: (eventId, directoryId) => {
        return {
            type: 'RESET_DIRECTORY_FILTER',
            eventId,
            directoryId,
        };
    },
};
